import { FC } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { setViewerPdf } from 'store/file/slice';
import { useAppDispatch } from 'store/hooks';
import { useTranslation } from 'react-i18next';

import { getFileUrl } from 'utils/file';

interface IProps {
  file?: string;
  id: string;
}

const DownloadInvoice: FC<IProps> = ({ file, id }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const onDownloadInvoice = () => {
    const url = file
      ? getFileUrl(file, undefined, null)
      : `/appointments/invoice/${id}`;

    dispatch(setViewerPdf({ id, url: url }));
  };

  return (
    <Link
      to={`/pdf-viewer/${id}`}
      target="_blank"
      rel="noreferrer"
      onClick={onDownloadInvoice}
    >
      <Button size="large" type="default" icon={<DownloadOutlined />}>
        {t('invoices.download')}
      </Button>
    </Link>
  );
};

export default DownloadInvoice;
